'use client'

import * as React from 'react'
import { InputMask } from '@react-input/mask'
import { Input } from '@/components/ui/input'

export interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, value, onChange, ...props }, ref) => {
    return (
      <InputMask
        mask="+38 0__ ___ __ __"
        replacement={{ _: /\d/ }}
        value={value}
        onChange={onChange}
        component={Input}
        ref={ref}
        className={className}
        {...props}
      />
    )
  },
)

PhoneInput.displayName = 'PhoneInput'

export { PhoneInput }
